export enum BusinessHistoryCategory {
    ACCOUNTS = 'ACCOUNTS',
    EMAIL_DOMAINS = 'EMAIL_DOMAINS',
    ENTERPRISE_PREFERENCES = 'ENTERPRISE_PREFERENCES',
    MFA = 'MFA',
    PASSWORDS = 'PASSWORDS',
    SITES = 'SITES',
    USERS = 'USERS',
    AUDIT_REPORTS = 'AUDIT_REPORTS',
    INACTIVITY_TIMEOUT = 'INACTIVITY_TIMEOUT'
}
